export const promoRedeemErrorMessageMap: Record<string, string> = {
    PROMO_CODE_REQUIRED: "w_TranslationJobTopupRedeemEmpty",
    PROMO_NOT_FOUND: "w_TranslationJobTopupRedeemNotFound",
    PROMO_DISABLED: "w_TranslationJobTopupRedeemDisabled",
    PROMO_NOT_STARTED: "w_TranslationJobTopupRedeemNotStarted",
    PROMO_EXPIRED: "w_TranslationJobTopupRedeemExpired",
    PROMO_MAX_USES: "w_TranslationJobTopupRedeemMaxUses",
    PROMO_NOT_CREDIT: "w_TranslationJobTopupRedeemNotCredit",
    PROMO_CREDIT_INVALID: "w_TranslationJobTopupRedeemInvalid",
    PROMO_PER_ORG_LIMIT: "w_TranslationJobTopupRedeemOrgLimit",
    PROMO_ORG_NOT_FOUND: "w_TranslationJobTopupRedeemOrgNotFound",
    PROMO_WALLET_NOT_FOUND: "w_TranslationJobTopupRedeemWalletNotFound",
    PROMO_REDEEM_FAILED: "w_TranslationJobTopupRedeemFailed",
};
export const promoRedeemFallbackKey = "w_TranslationJobTopupRedeemFailed";

export const promoValidateErrorMessageMap: Record<string, string> = {
    PROMO_CODE_REQUIRED: "w_TranslationJobTopupDiscountEmpty",
    PROMO_NOT_FOUND: "w_TranslationJobTopupDiscountNotFound",
    PROMO_DISABLED: "w_TranslationJobTopupDiscountDisabled",
    PROMO_NOT_STARTED: "w_TranslationJobTopupDiscountNotStarted",
    PROMO_EXPIRED: "w_TranslationJobTopupDiscountExpired",
    PROMO_MAX_USES: "w_TranslationJobTopupDiscountMaxUses",
    PROMO_NOT_DISCOUNT: "w_TranslationJobTopupDiscountNotDiscount",
    PROMO_MIN_SPEND: "w_TranslationJobTopupDiscountMinSpend",
    PROMO_PER_ORG_LIMIT: "w_TranslationJobTopupDiscountOrgLimit",
    PROMO_DISCOUNT_INVALID: "w_TranslationJobTopupDiscountInvalid",
};
export const promoValidateFallbackKey = "w_TranslationJobTopupDiscountInvalid";
